let LinkifyContainer;
if (process.env.WEB !== 'true') {
  LinkifyContainer = require('modules/text/mobile/textBody.component').default;
} else {
  LinkifyContainer = require('linkifyjs/react');
}

export const Linkify = LinkifyContainer;
